export default {
  classPrefix: 't',
} as const;
